import Bar from "../Bar";
import InfoButton from "../buttons/InfoButton";
import SoundButton from "../buttons/SoundButton";
import BankButton from "../buttons/BankButton";
import HomeButton from "../buttons/HomeButton";
import AccountButton from "../buttons/UserButton";
import FullscreenButton from "../buttons/FullscreenButton";
import classes from "../../styles/Bar.module.css";
import { getClasses } from "../../utils";

const ControlsBar: React.FC = () => {

  return (
    <Bar
      className={getClasses(classes, "landscape-buttons-controls align center")}
    >
      <InfoButton />
      <BankButton />
      <HomeButton />
      <AccountButton />
      <SoundButton />
      <FullscreenButton />
    </Bar>
  );
};

export default ControlsBar;
